'use client';

import { I18nProvider as _I18nProvider } from '@crehana/i18n';

import { useLanguage } from '../contexts/Language';

export const I18nProviderWithLanguage = ({
  children,
}: React.PropsWithChildren) => {
  const language = useLanguage();
  return <_I18nProvider languageCode={language}>{children}</_I18nProvider>;
};
